import React from "react";
import PredictionPage from "../../components/PredictionPage";

function NAS100() {
  return (
    <PredictionPage
      title="NAS100"
      content="This is the NAS100 AI Trading Predictions page."
      canonical="/indices/nas100-ai-trading-predictions"
      categoryKey="nav.indices"
      categoryPath="/indices"
      symbol="NAS100"
    />
  );
}

export default NAS100;
